import React from "react";
import { WhatseasTracking as Icon_WhatseasTracking } from "@/components/customer/icons/WhatseasTracking";
import { WhatseaseBot as Icon_WhatseaseBot } from "@/components/customer/icons/WhatseaseBot";
import { WhatseaseCampaingn as Icon_WhatseaseCampaingn } from "@/components/customer/icons/WhatseaseCampaingn";
import { WhatseaseConnect as Icon_WhatseaseConnect } from "@/components/customer/icons/WhatseaseConnect";
import { WhatseaseUpload as Icon_WhatseaseUpload } from "@/components/customer/icons/WhatseaseUpload";
const SvgIcons = { WhatseasTracking: Icon_WhatseasTracking, WhatseaseBot: Icon_WhatseaseBot, WhatseaseCampaingn: Icon_WhatseaseCampaingn, WhatseaseConnect: Icon_WhatseaseConnect, WhatseaseUpload: Icon_WhatseaseUpload };

export default function StepsLayout() {
  const steps = [
    { number: 1, title: "Connect your Whatsapp Business Account", icon: "link" },
    { number: 2, title: "Upload Your Audience", icon: "user-plus" },
    { number: 3, title: "Create Campaigns & Templates", icon: "megaphone" },
    { number: 4, title: "Design Bot Flows", icon: "bot" },
    { number: 5, title: "Track Everything in Real Time", icon: "chart" },
  ];

  // Icon Components
  function LinkIcon() {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 13C11.1046 13 12 12.1046 12 11C12 9.89543 11.1046 9 10 9C8.89543 9 8 9.89543 8 11C8 12.1046 8.89543 13 10 13Z"
          fill="#0A5F2F"
        />
        <path
          d="M15 7H9C7.89543 7 7 7.89543 7 9V13C7 14.1046 7.89543 15 9 15H15C16.1046 15 17 14.1046 17 13V9C17 7.89543 16.1046 7 15 7Z"
          stroke="#0A5F2F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  function UserPlusIcon() {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
          stroke="#0A5F2F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
          stroke="#0A5F2F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M19 8V14" stroke="#0A5F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22 11H16" stroke="#0A5F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  function MegaphoneIcon() {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 11H5C5.53043 11 6.03914 11.2107 6.41421 11.5858C6.78929 11.9609 7 12.4696 7 13V16C7 16.5304 6.78929 17.0391 6.41421 17.4142C6.03914 17.7893 5.53043 18 5 18H3C2.46957 18 1.96086 17.7893 1.58579 17.4142C1.21071 17.0391 1 16.5304 1 16V13C1 12.4696 1.21071 11.9609 1.58579 11.5858C1.96086 11.2107 2.46957 11 3 11Z"
          stroke="#0A5F2F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 13L14 6C14.5304 6 15.0391 6.21071 15.4142 6.58579C15.7893 6.96086 16 7.46957 16 8V16C16 16.5304 15.7893 17.0391 15.4142 17.4142C15.0391 17.7893 14.5304 18 14 18L7 13Z"
          stroke="#0A5F2F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 8C19.5913 8.52813 20.9673 9.5251 21.9435 10.8509C22.9197 12.1767 23.4493 13.7717 23.4493 15.4091C23.4493 17.0465 22.9197 18.6415 21.9435 19.9673C20.9673 21.2931 19.5913 22.2901 18 22.8182"
          stroke="#0A5F2F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  function BotIcon() {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2L17 6.5V10.5L12 15L7 10.5V6.5L12 2Z"
          stroke="#0A5F2F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 10.5L21 14.5V18.5L17 22.5L13 18.5V14.5L17 10.5Z"
          stroke="#0A5F2F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 10.5L3 14.5V18.5L7 22.5L11 18.5V14.5L7 10.5Z"
          stroke="#0A5F2F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M12 15V22.5" stroke="#0A5F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17 6.5L7 6.5" stroke="#0A5F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  function ChartIcon() {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 3V21H21" stroke="#0A5F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 14L11 10L15 14L21 8" stroke="#0A5F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M21 12V8H17" stroke="#0A5F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  // StepItem Component
  function StepItem({ number, title, icon }) {
    const getIcon = () => {
      switch (icon) {
        case "link":
          return <SvgIcons.WhatseaseConnect />;
        case "user-plus":
          return <SvgIcons.WhatseaseUpload />;
        case "megaphone":
          return <SvgIcons.WhatseaseCampaingn />;
        case "bot":
          return <SvgIcons.WhatseaseBot />;
        case "chart":
          return <SvgIcons.WhatseasTracking />;
        default:
          return null;
      }
    };

    return (
      <div className="md:w-1/2 w-full max-w-7xl mx-auto">
        <div className="flex flex-col items-center justify-center relative  px-2">

          {/* <div className="hidden md:block absolute top-[110px] left-0 w-full h-0.5 bg-[#7B9E88] transform -translate-y-1/2"></div> */}
          {/* Icon circle */}
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-[#EDFEE4]">
            <div className="text-green-900">{getIcon()}</div>
          </div>

          {/* Number circle */}
          <div className="bg-white px-5">
            <div className="flex items-center bg-white justify-center w-8 h-8 rounded-full border border-gray-300 my-4">
              <span className="text-sm bg-white">{number}</span>
            </div>
          </div>

          {/* Title */}
          <div className="text-center max-w-[450px] h-[50px]">
            <p className="font-Schibsted_Grotesk text-[16px] md:text-[18px] font-normal leading-[120%]">{title}</p>
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className="container mx-auto px-4">

      <div className="flex flex-col relative md:flex-row items-center justify-center md:space-x-4 lg:space-x-8">
        <div className="bg-[#7B9E88] hidden md:block h-[0.8px] absolute bottom-[76px] w-[75%] mx-auto"></div>
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <StepItem number={step.number} title={step.title} icon={step.icon} />

            {/* Connector line between steps (only for desktop and not after the last item) */}
            {/* {index < steps.length - 1 && (
              <div className="hidden md:block h-[1px] bg-gray-300 flex-grow max-w-[120px]"></div>
            )} */}

            {/* Add vertical spacing on mobile */}
            {/* {index < steps.length - 1 && <div className="md:hidden h-12"></div>} */}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}



//             <div className="relative flex flex-col md:flex-row justify-between items-center gap-6 md:gap-0">
//               <div className="hidden md:block absolute top-[110px] left-0 w-full h-0.5 bg-[#7B9E88] transform -translate-y-1/2"></div>

//               <div className="flex flex-col items-start z-10 relative">
//                 <div className="mb-[24px] rounded-[36px] bg-[#EDFEE4] flex w-[72px] h-[72px] p-[18px] justify-center items-center shrink-0 aspect-square">
//                   <SvgIcons.WhatseaseConnect />
//                 </div>
//                 <div className='px-[10px] bg-white'>
//                   <p className=" flex w-8  h-8  flex-col justify-center items-center  gap-2.5  aspect-[1/1] rounded-[24px] border-[0.8px]  border-[#143C23]
//  text-[#143C23] text-center  font-LatinkaMedium text-[16px] font-normal"
//                   >1</p>
//                 </div>
//                 <p className="text-[#090D28]  text-center relative md:absolute -bottom-16 -left-16 w-[200px] font-LatinkaMedium text-[16px] md:text-[18px] font-normal leading-[120%] pt-[24px]">Connect your WhatsApp Business Account</p>
//               </div>

//               <div className="flex flex-col items-center z-10 relative">
//                 <div className="mb-[24px] rounded-[36px] bg-[#EDFEE4] flex w-[72px] h-[72px] p-[18px] justify-center items-center shrink-0 aspect-square">
//                   <SvgIcons.WhatseaseUpload />
//                 </div>
//                 <div className='px-[10px] bg-white'>

//                   <p className=" flex w-8  h-8  flex-col justify-center items-center  gap-2.5  aspect-[1/1] rounded-[24px] border-[0.8px]  border-[#143C23]
//  text-[#143C23] text-center  font-LatinkaMedium text-[16px] font-normal"
//                   >2</p>
//                 </div>

// <p className="text-[#090D28]  text-center relative md:absolute -bottom-16 -left-16 w-[200px] font-LatinkaMedium text-[16px] md:text-[18px] font-normal leading-[120%] pt-[24px]">Upload Your Audience</p>
//                 {/* <p className="text-[#090D28] absolute bottom-0 text-center font-LatinkaMedium text-[16px] md:text-[18px] font-normal leading-[120%] pt-[24px]"></p> */}
//               </div>

//               <div className="flex flex-col items-center z-10 relative">
//                 <div className="mb-[24px] rounded-[36px] bg-[#EDFEE4] flex w-[72px] h-[72px] p-[18px] justify-center items-center shrink-0 aspect-square">
//                   <SvgIcons.WhatseaseCampaingn />
//                 </div>
//                 <div className='px-[10px] bg-white'>

//                   <p className=" flex w-8  h-8  flex-col justify-center items-center  gap-2.5  aspect-[1/1] rounded-[24px] border-[0.8px]  border-[#143C23]
//  text-[#143C23] text-center  font-LatinkaMedium text-[16px] font-normal"
//                   >3</p>
//                 </div>

//                 <p className="text-[#090D28] absolute bottom-0 text-center font-LatinkaMedium text-[16px] md:text-[18px] font-normal leading-[120%] pt-[24px]">Create Campaign Templates</p>
//               </div>

//               <div className="flex flex-col items-center z-10 relative">
//                 <div className="mb-[24px] rounded-[36px] bg-[#EDFEE4] flex w-[72px] h-[72px] p-[18px] justify-center items-center shrink-0 aspect-square">
//                   <SvgIcons.WhatseaseBot />
//                 </div>
//                 <div className='px-[10px] bg-white'>
//                   <p className=" flex w-8  h-8  flex-col justify-center items-center  gap-2.5  aspect-[1/1] rounded-[24px] border-[0.8px]  border-[#143C23]
//  text-[#143C23] text-center  font-LatinkaMedium text-[16px] font-normal"
//                   >4</p>
//                 </div>        <p className="text-[#090D28] absolute bottom-0 text-center font-LatinkaMedium text-[16px] md:text-[18px] font-normal leading-[120%] pt-[24px]">Design Bot Flows</p>
//               </div>

//               <div className="flex flex-col items-end z-10">
//                 <div className="mb-[24px] rounded-[36px] bg-[#EDFEE4] flex w-[72px] h-[72px] p-[18px] justify-center items-center shrink-0 aspect-square">
//                   <SvgIcons.WhatseasTracking />
//                 </div>
//                 <div className='px-[10px] bg-white'>

//                   <p className=" flex w-8  h-8  flex-col justify-center items-center  gap-2.5  aspect-[1/1] rounded-[24px] border-[0.8px]  border-[#143C23]
//  text-[#143C23] text-center  font-LatinkaMedium text-[16px] font-normal"
//                   >5</p>
//                 </div>

//                 <p className="text-[#090D28] absolute bottom-0 text-center font-LatinkaMedium text-[16px] md:text-[18px] font-normal leading-[120%] pt-[24px]">Track Everything in Real Time</p>
//               </div>
//             </div>